import InfoTag from "pages/echeck/components/InfoTag";
import Button from "pages/_components/Button";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";
import GridTable from "pages/_components/GridTable/GridTable";
import { bool, shape, string } from "prop-types";
import React, { memo } from "react";
import { useDispatch } from "react-redux";
import { actions as creditBillActions } from "reducers/creditBills";
import { getBoolOption, statusTagColor, monedas } from "util/creditBills";

const ActionBillItem = memo(({ billItem, tabOption, showButton, isFinished, isDesktop }) => {
    const dispatch = useDispatch();
    const { isEmitted, isInTenure, isToPay, isReceived } = getBoolOption(tabOption);
    const handleDeleteItem = () => {
        dispatch(creditBillActions.setBillList(billItem.facturaId.numeroComprobante));
    };
    return (
        <>
            {isEmitted && (
                <>
                    <GridTable.Data columnStart={1} rowStart={1} rowWidth={1}>
                        <CustomData
                            titleText="creditBill.table.debtor"
                            titleTextType="I18N"
                            valueText={`${billItem.cuitComprador} \n ${billItem.razonSocialComprador}`}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2} rowWidth={1}>
                        <CustomData
                            titleText="creditBill.table.holder"
                            titleTextType="I18N"
                            valueText={`${billItem.cuitTenedor} \n ${billItem.razonSocialTenedor}`}
                        />
                    </GridTable.Data>
                </>
            )}
            {isReceived && (
                <>
                    <GridTable.Data columnStart={1} rowStart={1} rowWidth={1}>
                        <CustomData
                            titleText="creditBill.table.emitter"
                            titleTextType="I18N"
                            valueText={`${billItem.razonSocialEmisor} \n ${billItem.facturaId.cuitEmisor}`}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2} rowWidth={1}>
                        <CustomData
                            titleText="creditBill.table.holder"
                            titleTextType="I18N"
                            valueText={`${billItem.razonSocialTenedor} \n ${billItem.cuitTenedor}`}
                        />
                    </GridTable.Data>
                </>
            )}
            {isToPay && (
                <>
                    <GridTable.Data columnStart={1} rowStart={1} rowWidth={1}>
                        <CustomData
                            titleText="creditBill.table.holder"
                            titleTextType="I18N"
                            valueText={`${billItem.razonSocialTenedor} \n ${billItem.cuitTenedor}`}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2} rowWidth={1}>
                        <CustomData
                            titleText="creditBill.table.emitter"
                            titleTextType="I18N"
                            valueText={`${billItem.razonSocialEmisor} \n ${billItem.facturaId.cuitEmisor}`}
                        />
                    </GridTable.Data>
                </>
            )}
            {isInTenure && (
                <>
                    <GridTable.Data columnStart={1} rowStart={1} rowWidth={1}>
                        <CustomData
                            titleText="creditBill.table.emitter"
                            titleTextType="I18N"
                            valueText={`${billItem.razonSocialEmisor} \n ${billItem.facturaId.cuitEmisor}`}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2} rowWidth={1}>
                        <CustomData
                            titleText="creditBill.table.debtor"
                            titleTextType="I18N"
                            valueText={`${billItem.razonSocialComprador} \n ${billItem.cuitComprador}`}
                        />
                    </GridTable.Data>
                </>
            )}

            <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 3} rowWidth={1}>
                <CustomData
                    titleText="creditBill.table.emission"
                    titleTextType="I18N"
                    valueText={<FormattedDate date={billItem.fechaEmision} />}
                />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 4 : 1} rowStart={isDesktop ? 1 : 4} rowWidth={1}>
                <CustomData
                    titleText="creditBill.table.expiration"
                    titleTextType="I18N"
                    valueText={<FormattedDate date={billItem.fechaVencimientoPago} />}
                />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 5 : 1} rowStart={isDesktop ? 1 : 5} rowWidth={1}>
                <CustomData
                    titleText="creditBill.table.amount"
                    titleTextType="I18N"
                    valueText={
                        <FormattedAmount currency={monedas[billItem.moneda]} quantity={billItem.saldoAceptado} />
                    }
                />
            </GridTable.Data>
            {!isFinished && (
                <GridTable.Data
                    columnStart={isDesktop ? 6 : 2}
                    rowStart={1}
                    rowWidth={1}
                    className="info-tag-credit-bill">
                    <InfoTag
                        type="info"
                        message={billItem.estadoFactura}
                        tagBackground={statusTagColor(billItem.estadoFactura)}
                    />
                </GridTable.Data>
            )}
            {showButton && (
                <GridTable.Data columnStart={isDesktop ? 7 : 3} rowStart={isDesktop ? 1 : 5} rowWidth={1}>
                    <Button bsStyle="link" onClick={handleDeleteItem} image="images/trash.svg" />
                </GridTable.Data>
            )}
        </>
    );
});

ActionBillItem.propTypes = {
    billItem: shape({}).isRequired,
    tabOption: string.isRequired,
    showButton: bool,
    isFinished: bool,
    isDesktop: bool.isRequired,
};

ActionBillItem.defaultProps = {
    showButton: false,
    isFinished: false,
};

export default ActionBillItem;
